// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2cGDi","label":"Labeled_label__vubOO","divider":"Labeled_divider__CVboO"};